module.exports = __webpack_public_path__ + "img/multimedia_active_orange.7d18cef5.svg";